<ng-container>
    <div class="overlay-warp">
        <div class="itemx" *ngFor="let item of statusList">
            <div [ngSwitch]="item.status">
                <div class="item-list">
                    <div class="choose"  [ngClass]="{'selected': item.choosed}" (click)="selectStatus(item)">
                        <div class="inner-selected">
                            <img src="/assets/images/auto-fill/vi.svg">
                        </div>
                    </div>
                    <div *ngSwitchCase="enumQStatus.NotStarted" class="st edit">
                        <img class="img" src="/assets/images/grid/status/edit.svg">
                        <p translate>grid.status.not-started</p>
                    </div>
                    <div *ngSwitchCase="enumQStatus.InProgress" class="st distributed">
                        <img class="img"src="/assets/images/grid/status/distributed.svg">
                        <p translate>grid.status.in-progress</p>
                    </div>
                    <div *ngSwitchCase="enumQStatus.Finished" class="st respond">
                        <img class="img" src="/assets/images/grid/status/answered.svg">
                        <p translate> grid.status.finished</p>
                    </div>
                    <div *ngSwitchCase="enumQStatus.PendingApproval" class="st pendingApproval">
                        <img class="img" src="/assets/images/grid/status/hourglass.svg">
                        <p translate> grid.status.pendingApproval</p>
                    </div>
                     <div *ngSwitchCase="enumQStatus.Approved" class="st approved">
                        <img class="img" src="/assets/images/grid/status/check_circle.svg">
                        <p translate> grid.status.approved</p>
                    </div>
                     <div *ngSwitchCase="enumQStatus.Rejected" class="st rejected">
                        <img class="img" src="/assets/images/grid/status/cancel.svg">
                        <p translate> grid.status.rejected</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>